import React, { RefObject } from 'react';
import cs from 'classnames';
import { StreamChatChannel } from 'shared/messaging/types';
import ChannelListAvatar from './ChannelListAvatar';

interface Props {
  isCreator: boolean;
  channel: StreamChatChannel;
  displayImage?: string;
  displayTitle?: string;
  renderMessageText?: () => string | React.ReactElement<{ children: string }>;
  previewRef: RefObject<HTMLButtonElement>;
  unreadClass?: string;
  activeClass?: string;
  onClick: () => void;
}

const ChannelListItem: React.FC<Props> = ({
  isCreator,
  channel,
  displayImage,
  displayTitle,
  renderMessageText,
  previewRef,
  activeClass = '',
  unreadClass = '',
  onClick,
}) => {
  return (
    <div className="str-chat__channel-preview-container">
      <button
        data-testid="channel-preview-button"
        type="button"
        onClick={onClick}
        ref={previewRef}
        className={cs('str-chat__channel-preview-messenger', 'str-chat__channel-preview', unreadClass, activeClass)}
      >
        <ChannelListAvatar isCreator={isCreator} channel={channel} image={displayImage} name={displayTitle} />
        <div className="str-chat__channel-preview-end">
          <div className="str-chat__channel-preview-end-first-row">
            <div className="str-chat__channel-preview-messenger--name">
              <span>{displayTitle}</span>
            </div>
          </div>
          {renderMessageText && (
            <div className="str-chat__channel-preview-messenger--last-message">
              {!channel.state.messages[0] ? 'Nothing yet...' : renderMessageText()}
            </div>
          )}
        </div>
      </button>
    </div>
  );
};

export default ChannelListItem;
